export enum TimeFormats {
  ServerFormatDateTime = 'YYYY-MM-DD HH:mm', //hh - 12hours am/pm format, HH - 24hours format
  ServerFormatDate = 'YYYY-MM-DD',
  ServerFormatDateTimeWithSec = 'YYYY-MM-DD HH:mm:ss', 

  Time24 = 'HH:mm',
  Time12 = 'h:mm A',
  
  UIFormatDatePicker = 'MMM d - HH:mm',
  UIFormatDatePickerWithoutTime = 'MMM d',
  UIFormatDate = 'ddd, DD MMM',
  UIFormatDateTime = 'ddd, DD MMM, HH:mm',
  UIFormatDateYearTime = 'ddd, DD MMM YYYY, HH:mm',
}